var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"swiper-lazy",class:_vm.isClickable ? 'pointer' : '',style:(_vm.renderImage),on:{"click":_vm.onBannerClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }